import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import TableContainer from '../../../Components/Common/TableContainer';
import { PageHeader } from '../../../Components/Custom/PageHeader';
import { SearchInputFilter } from '../../../Components/Custom/SearchInputFilter';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { columns } from './columns';
import {
  exportDirectBonus,
  exportHeaders,
  getDirectBonus,
  removeDirectBonusForExport
} from './slice';
import { SearchSubmitButton } from '../../../Components/Custom/SearchSubmitButton';
import { CsvExport } from '../../../Components/Custom/CsvExport';
import { dateForExport } from '../../../helpers/helpers';
import { Filters } from './filters';
import { paramsForExport } from '../TeamBonus/slice';
import { Pagination } from '../../../Components/Custom/pagination';

const PAGE_TITLE = 'Direct Bonus';

const INITIAL_PARAMS: {
  countPerPage: string;
  numberOfPage: string;
} = {
  countPerPage: '10',
  numberOfPage: '1'
};

const DirectBonusPage = () => {
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams(INITIAL_PARAMS);
  const { loading, loadingExport, data, dataForExport, totalCount } =
    useAppSelector((state) => state.directBonus);

  useEffect(() => {
    dispatch(getDirectBonus(searchParams));
  }, [searchParams]);

  document.title = 'Package Orders | United One Admin';
  return (
    <div className='page-content'>
      <Container fluid>
        <BreadCrumb title={PAGE_TITLE} pageTitle='Bonuses' />
        <Row>
          <Col lg={12}>
            <Card id='orderList'>
              <PageHeader
                loading={loading || loadingExport}
                initialParams={INITIAL_PARAMS}
                setSearchParams={setSearchParams}
                title={PAGE_TITLE}
                actions={
                  <>
                    <CsvExport
                      action={() =>
                        dispatch(
                          exportDirectBonus(paramsForExport(searchParams))
                        )
                      }
                      data={dataForExport}
                      headers={exportHeaders}
                      disabled={loading || loadingExport}
                      fileName={`directBonus-${dateForExport}`}
                      removeDataAction={removeDirectBonusForExport}
                      buttonName='Export filtered data'
                    />
                  </>
                }
              />
              <CardBody className='pt-0'>
                <Filters
                  params={searchParams}
                  setParams={setSearchParams}
                  initialParams={INITIAL_PARAMS}
                />

                {/* {data?.userDirectBonuses[0]?.userPackage && (
                  <CardBody className='border border-dashed border-end-0 border-start-0'>
                    <Row>
                      <Col md={3} sm={4}>
                        Order ID: {data?.userDirectBonuses[0]?.userPackage.id}
                      </Col>
                      <Col md={3} sm={4}>
                        Order Date:{' '}
                        {moment(
                          data?.userDirectBonuses[0]?.userPackage.dateCreated
                        ).format('DD.MM.YYYY')}
                      </Col>
                      <Col md={3} sm={4}>
                        ORDER USER ID:{' '}
                        {data?.userDirectBonuses[0]?.userPackage.userId}
                      </Col>
                      <Col md={3} sm={4}>
                        ORDER Value:{' '}
                        {data?.userDirectBonuses[0]?.userPackage.price}
                      </Col>
                    </Row>
                  </CardBody>
                )} */}

                <TableContainer
                  columns={columns}
                  data={data?.userDirectBonuses || []}
                  divClass='table-responsive table-card mb-1'
                  tableClass='align-middle table-nowrap'
                  theadClass='table-light text-muted'
                />

                <Pagination
                  totalCount={totalCount}
                  data={data?.userDirectBonuses}
                  params={searchParams}
                  setParams={setSearchParams}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DirectBonusPage;
